<template>
  <div>
    <b-modal
      centered
      :ref="id"
      :id="id"
      :title="$t('organization.members.delete', { name: member.name })"
      scrollable
      size="lg"
      title-class="font-18"
      v-model="show"
      @hidden="onHide"
    >
      <div>
        <div>
          <b-alert show variant="primary">
            <span v-html="$t('organization.members.handover-to-heir')"> </span>
          </b-alert>

          <div class="mt-4 mb-4">
            <organization-member-select :selected="payload.heir" @onSelect="onMemberSelect" :ignore="[member._id]" :organization="currentOrganization" />
          </div>
          <div class="placeholder"></div>
        </div>
        <b-alert show variant="warning">
          <span v-html="$t('organization.members.delete-info', { name: member.name })"> </span>
        </b-alert>
        <sweet-button class="mt-4" @click="remove()" :disabled="isDisabled" :loading="isUpdating" variant="danger" icon="mdi mdi-delete" :block="true">
          <span v-html="$t('common.delete')"></span>
        </sweet-button>
      </div>

      <template #modal-footer>
        <div class="w-100 text-right">
          <sweet-button @click="show = false" variant="secondary" icon="mdi mdi-cancel" size="sm" buttonClass="ml-2">
            {{ $t("common.cancel") }}
          </sweet-button>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
import OrganizationMemberSelect from "@cc/organization-member-select";
import { required } from "vuelidate/lib/validators";
export default {
  props: ["id", "member", "strict"],
  components: { OrganizationMemberSelect },
  data() {
    return {
      payload: { id: undefined, heir: null },
      show: false,
    };
  },
  validations: {
    payload: {
      heir: {
        required,
      },
    },
  },
  computed: {
    isLoading() {
      return this.$store.getters["organizationMember/isLoading"];
    },
    isUpdating() {
      return this.$store.getters["organizationMember/isUpdating"];
    },
    isDisabled() {
      return this.isLoading || !this.payload.heir;
    },
  },
  mounted() {
    this.$v.$touch();
  },
  methods: {
    async remove() {
      this.payload.id = this.member._id;

      this.$emit("remove", this.payload);
    },
    onMemberSelect(item) {
      this.payload = { ...this.payload, heir: item };
    },
    onHide() {
      this.$emit("onHide");
    },
  },
};
</script>

<style scoped>
.placeholder {
  height: 50px;
}
</style>
